"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ObjectId = require('bson').ObjectID;
var PersonReference = require('../core/person-reference');
var errorValidator = require('../../helper/flexible-questionnaire/fq-helper');
var FlexibleQuestionnaire = /*#__PURE__*/function () {
  function FlexibleQuestionnaire(opt) {
    _classCallCheck(this, FlexibleQuestionnaire);
    this._id = null;
    this.responses = null;
    this.templateId = null;
    this.createdBy = null;
    this.createdDate = null;
    this.lastModifiedBy = null;
    this.lastModifiedDate = null;
    if (opt) {
      this.fillBaseObject(opt);
    }
  }
  _createClass(FlexibleQuestionnaire, [{
    key: "fillBaseObject",
    value: function fillBaseObject(opt) {
      this._id = new ObjectId(opt._id);
      this.responses = opt.responses;
      this.templateId = opt.templateId;
      this.createdBy = new PersonReference(opt.createdBy);
      this.createdDate = opt.createdDate ? new Date(opt.createdDate) : null;
      this.lastModifiedBy = new PersonReference(opt.lastModifiedBy);
      this.lastModifiedDate = opt.lastModifiedDate ? new Date(opt.lastModifiedDate) : null;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "isValid",
    value: function isValid(questions, answers) {
      return errorValidator.isFormValid(questions, answers);
    }
  }]);
  return FlexibleQuestionnaire;
}();
module.exports = FlexibleQuestionnaire;